import C from 'actionTypes'

export const setContactFinancialAccountRoles = data => ({
  type: C.SET_CONTACT_FINANCIAL_ACCOUNT_ROLES,
  data
})

export const editContactFinancialAccountRole = data => ({
  type: C.EDIT_CONTACT_FINANCIAL_ACCOUNT_ROLE,
  data
})

export const addContactFinancialAccountRole = data => ({
  type: C.ADD_CONTACT_FINANCIAL_ACCOUNT_ROLE,
  data
})

export const removeContactFinancialAccountRole = id => ({
  type: C.REMOVE_CONTACT_FINANCIAL_ACCOUNT_ROLE,
  id
})

export default {
  setContactFinancialAccountRoles,
  editContactFinancialAccountRole,
  addContactFinancialAccountRole,
  removeContactFinancialAccountRole
}



// WEBPACK FOOTER //
// ./src/actions/contactFinancialAccountRoles.js